const COOKIE_NAMES = {
  JWT: 'BNIJWTCookie2'
};

const IS_DEVELOPMENT = false;

const cookieUtils = {
  set(name, value, options = {}) {
    let cookie = `${name}=${value}`;

    if (options.path) {
      cookie += `;path=${options.path}`;
    }

    if (options.expires) {
      cookie += `;expires=${options.expires.toUTCString()}`;
    }

    if (!IS_DEVELOPMENT) {
      if (options.secure) {
        cookie += ';secure';
      }
      if (options.sameSite) {
        cookie += `;samesite=${options.sameSite}`;
      }
    }

    document.cookie = cookie;
  },

  get(name) {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [cookieName, cookieValue] = cookie.trim().split('=');
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  },

  remove(name, options = {}) {
    const cookieOptions = {
      ...options,
      expires: new Date(0)
    };
    this.set(name, '', cookieOptions);
  }
};

export const authService = {
  initialize() {
    const urlToken = this.getTokenFromUrl();
    if (urlToken) {
      this.setToken(urlToken);
      this.removeTokenFromUrl();
      return true;
    }
    return !!this.getToken();
  },

  getTokenFromUrl() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');
      return token;
    } catch (error) {
      console.error('Error extracting token from URL:', error);
      return null;
    }
  },

  removeTokenFromUrl() {
    try {
      const url = new URL(window.location);
      url.searchParams.delete('token');
      window.history.replaceState({}, '', url);
    } catch (error) {
      console.error('Error removing token from URL:', error);
    }
  },

  isAuthenticated() {
    const token = this.getToken();
    if (!token) {
      return false;
    }

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Math.floor(Date.now() / 1000);
      return payload.exp > currentTime;
    } catch (error) {
      console.error('Error checking authentication:', error);
      return false;
    }
  },

  getMemberId() {
    try {
      const token = this.getToken();
      if (!token) {
        return null;
      }

      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.RelationReference || null;
    } catch (error) {
      console.error('Error extracting member ID:', error);
      return null;
    }
  },

  getToken() {
    try {
      if (typeof window.getToken === 'function') {
        try {
          const globalToken = window.getToken();
          if (globalToken) {
            return globalToken;
          }
        } catch (globalTokenError) {
          console.error('Error getting token from global function:', globalTokenError);
        }
      }
      const cookieToken = cookieUtils.get(COOKIE_NAMES.JWT);
      if (cookieToken) {
        return cookieToken;
      }

      return null;
    } catch (error) {
      console.error('Error getting token:', error);
      return null;
    }
  },

  setToken(token) {
    try {
      cookieUtils.set(COOKIE_NAMES.JWT, token, {
        path: '/',
        secure: true,
        sameSite: 'Lax'
      });
      return true;
    } catch (error) {
      console.error('Error setting token:', error);
      return false;
    }
  },

  clearToken() {
    try {
      cookieUtils.remove(COOKIE_NAMES.JWT, {
        path: '/',
        secure: true,
        sameSite: 'Lax'
      });
    } catch (error) {
      console.error('Error clearing token:', error);
    }
  }
};

export default authService;